// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"ea70ed11","787":"b19b7478"}[chunkId] + ".chunk.js";
};